import { useEffect, useState } from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { store } from "./store/store";
import Login from "./pages/Login";
import PrivateRoute from "./PrivateRoute";
import NotFound from "./pages/NotFound";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Enquiry from "./pages/Enquiry";
import SessionExpiredModal from "./components/SessionExpiredModal";
// Forgot-password flow disabled — password reset is now only possible for a
// logged-in admin via the authenticated /register/update endpoint. Re-enable
// this import + the route below only alongside a secure (OTP-verified) reset.
// import ForgotPassword from "./pages/ForgotPassword";

function AppContent() {
  const location = useLocation();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (
      token &&
      (location.pathname === "/" || location.pathname === "/forgot-password")
    ) {
      window.location.href = "/dashboard";
    }

    setIsInitialized(true);
  }, [location]);

  const isLoginPage =
    location.pathname === "/" || location.pathname === "/forgot-password";

  if (!isInitialized) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      {!isLoginPage && <Header />}
      <div className="main-section">
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Login />} />
          {/* Forgot-password route disabled — see import comment above. */}
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Enquiry />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!isLoginPage && <Footer />}
      <SessionExpiredModal />
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
